/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

export default function data(
  roles = [],
  onManageEndpointsClick = () => {},
  onToggleStatusClick = () => {},
  statusUpdatingRoleId = null
) {
  const Role = ({ name, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="button" fontWeight="medium">
        {name}
      </MDTypography>
      <MDTypography variant="caption" color="text">
        {description}
      </MDTypography>
    </MDBox>
  );

  const getId = (item) => item?.roleId ?? item?.RoleId ?? item?.id ?? item?.Id ?? null;
  const getName = (item) => item?.name ?? item?.Name ?? "";
  const getDescription = (item) => item?.description ?? item?.Description ?? "";
  const getIsActive = (item) => {
    const value = item?.isActive ?? item?.IsActive;
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return normalized === "true" || normalized === "1" || normalized === "active";
    }
    return false;
  };

  return {
    columns: [
      {
        Header: "role",
        accessor: "roleSearch",
        width: "45%",
        align: "left",
        Cell: ({ row }) => (
          <Role name={row.original.roleName} description={row.original.roleDescription} />
        ),
      },
      {
        Header: "status",
        accessor: "statusText",
        align: "center",
        Cell: ({ row }) => row.original.status,
      },
      {
        Header: "action",
        accessor: "actionText",
        align: "center",
        Cell: ({ row }) => (
          <MDBox display="flex" justifyContent="center" gap={1} flexWrap="wrap">
            <Tooltip title="Assign Endpoints" placement="top">
              <span>
                <IconButton
                  color="info"
                  size="small"
                  onClick={() => onManageEndpointsClick(row.original)}
                >
                  <Icon fontSize="small">device_hub</Icon>
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip
              title={row.original.isActive ? "Deactivate Role" : "Activate Role"}
              placement="top"
            >
              <span>
                <IconButton
                  color={row.original.isActive ? "error" : "success"}
                  size="small"
                  onClick={() => onToggleStatusClick(row.original)}
                  disabled={String(statusUpdatingRoleId) === String(row.original.roleId)}
                >
                  <Icon fontSize="small">{row.original.isActive ? "toggle_off" : "toggle_on"}</Icon>
                </IconButton>
              </span>
            </Tooltip>
          </MDBox>
        ),
      },
    ],

    rows: roles.map((item) => {
      const isActive = getIsActive(item);
      const roleId = getId(item);
      return {
        roleId,
        roleName: getName(item),
        roleDescription: getDescription(item),
        roleSearch: `${getName(item)} ${getDescription(item)}`.trim(),
        isActive,
        statusText: isActive ? "active" : "inactive",
        status: (
          <MDBadge
            badgeContent={isActive ? "active" : "inactive"}
            color={isActive ? "success" : "secondary"}
            variant="gradient"
            size="sm"
          />
        ),
        actionText: `ID: ${roleId ?? "-"}`,
        action: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {`ID: ${roleId ?? "-"}`}
          </MDTypography>
        ),
      };
    }),
  };
}
